import { render, staticRenderFns } from "./ListaAvaliacaoHabilidade.vue?vue&type=template&id=b91b8592"
import script from "./ListaAvaliacaoHabilidade.vue?vue&type=script&lang=js"
export * from "./ListaAvaliacaoHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports